import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';

interface ReportForRegisteredUserState {
    isLoading: boolean;
}

class ReportForRegisteredUser extends React.Component<any, ReportForRegisteredUserState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    private handleOnLoad = () => {
        this.setState({
            isLoading: false
        });
    }

    public render() {
        return (
            <>
                <Container fluid className="h-100">
                    <Row className="h-100">
                        <Col xs={12} className="px-0 d-flex justify-content-center flex-column">
                            {this.state.isLoading && (
                                <section className="align-self-center text-center">
                                    <p>Initiating QuickSight Dashboard...</p>
                                    <FontAwesomeIcon icon={faSpinner} size="3x" spin={true} />
                                </section>
                            )}
                            <iframe width="100%" height="100%" onLoad={this.handleOnLoad}
                                src={"https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/293536974461/dashboards/435bf54d-d34d-4a35-958d-8489c679b4d1"}>
                            </iframe>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default ReportForRegisteredUser;
